import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Box, IconButton, Typography } from "@mui/material";
import { useState } from "react";
import { MENU_ITEMS_PANEL_COLLAPSED_WIDTH, MENU_ITEMS_PANEL_EXPANDED_WIDTH } from "./constants";
import { MenuItemsPanelContent } from "./MenuItemsPanelContent";

interface MenuItemsSidePanelProps {
  isExpanded: boolean;
  onToggleExpanded: () => void;
}

export const MenuItemsSidePanel = ({ isExpanded, onToggleExpanded }: MenuItemsSidePanelProps) => {
  const [hasBeenExpanded, setHasBeenExpanded] = useState(isExpanded);
  if (isExpanded && !hasBeenExpanded) {
    setHasBeenExpanded(true);
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: isExpanded ? MENU_ITEMS_PANEL_EXPANDED_WIDTH : MENU_ITEMS_PANEL_COLLAPSED_WIDTH,
        height: "100%",
        bgcolor: "greyscale.50",
        borderTop: theme => `1px solid ${theme.palette.greyscale[300]}`,
        borderLeft: theme => `1px solid ${theme.palette.greyscale[300]}`,
        transition: theme =>
          theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: isExpanded ? 1 : 0.5,
          py: 1.5,
          minHeight: 56,
        }}
      >
        <IconButton
          size="small"
          aria-label={isExpanded ? "Collapse menu items panel" : "Expand menu items panel"}
          onClick={onToggleExpanded}
        >
          {isExpanded ? <KeyboardArrowRightIcon /> : <KeyboardArrowLeftIcon />}
        </IconButton>
        {isExpanded && (
          <Typography variant="h4" sx={{ fontWeight: 500, lineHeight: "24px" }}>
            Menu Items
          </Typography>
        )}
      </Box>
      {hasBeenExpanded && (
        <Box
          sx={{
            display: isExpanded ? "flex" : "none",
            flexDirection: "column",
            flex: 1,
            minHeight: 0,
          }}
        >
          <MenuItemsPanelContent />
        </Box>
      )}
    </Box>
  );
};
